var $8fb53a929b46df83$exports = {};
$8fb53a929b46df83$exports = {
    "close": `\u{9589}\u{3058}\u{308B}`,
    "notifications": `\u{901A}\u{77E5}`
};


export {$8fb53a929b46df83$exports as default};
//# sourceMappingURL=ja-JP.module.js.map
